/*
 * 图片预览组件
 * @Author: zwt.daffy
 * @Date: 2019-08-07 14:47:04
 * @Last Modified by: zwt.daffy
 * @Last Modified time: 2019-12-26 21:42:12
 */
<template>
  <section class="common-container image-preview">
    <el-dialog
      title="图片预览"
      width="600px"
      :visible="visible"
      @close="handleCloseDialog"
      class="image-preview-dialog"
    >
      <el-carousel v-if="mult" indicator-position="outside" :initial-index="imgIndex" height="500px">
        <el-carousel-item v-for="img in imgList" :key="img">
          <el-image fit="contain" :src="img" class="preview"/>
        </el-carousel-item>
      </el-carousel>
      <img v-else :src="imgSrc" class="preview">
    </el-dialog>
  </section>
</template>
<script>
export default {
  name: 'image-preview',
  props: {
    visible: {
      type: Boolean
    },
    imgSrc: {
      type: String
    },
    imgList: {
      type: Array
    },
    imgIndex: {
      type: Number,
      default: 0
    },
    mult: {
      type: Boolean
    },
    modal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  computed: {
    imgUrl () {
      return this.utils.getFullImageUrl(this.imgSrc)
    },
    imgUrlList () {
      return this.imageList.map(item => this.utils.getFullImageUrl(item))
    }
  },
  methods: {
    handleCloseDialog () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
.image-preview {
  .image-preview-dialog{
    background-color: rgba(0, 0, 0, 0.3);
  }
  .preview {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/components/common/ImagePreview.vue